export enum BonusActionType {
  BrowserNotifications = 1,
  PwaInstall = 2,
}
